import { render } from "./air_humidity.vue?vue&type=template&id=32b7f789"
import script from "./air_humidity.vue?vue&type=script&lang=js"
export * from "./air_humidity.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__